import instance from 'src/api/instance';

export async function backupDb() {
  const response = await instance.get<any>(`/backup`);
  return response;
}

export async function downloadDbBackup() {
  const response = await instance.get<any>(`/download-latest-backup`);
  return response;
}
